import { api } from '../index'

export default {
  location(address) {
    return api.get('/geocode', {
      params: address,
    });
  },
}
